var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"lymphomap_main"},[_c('div',{ref:"workspaceFrame",staticClass:"workspaceFrame",class:{
        collapsed_chat_list: _vm.isWorkspaceCollapsed,
        mobile_tools_open:
            _vm.isMobile && _vm.isMobileToolbarOpen
    }},[_c('ChatUserList',{attrs:{"initial-loading":_vm.isChatRoomsLoading},on:{"open-mobile-tools":_vm.openMobileToolbar}}),_c('WorkspaceRightSidebar',{attrs:{"expanded":_vm.isWorkspaceCollapsed,"is-mobile":_vm.isMobile},on:{"toggle":_vm.handleSidebarToggle}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }